import { render, staticRenderFns } from "./memberDetall.vue?vue&type=template&id=1c768be6&scoped=true&"
import script from "./memberDetall.vue?vue&type=script&lang=js&"
export * from "./memberDetall.vue?vue&type=script&lang=js&"
import style0 from "./memberDetall.vue?vue&type=style&index=0&id=1c768be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c768be6",
  null
  
)

export default component.exports